module.exports = __webpack_public_path__ + "img/university-alabama-logo.0a5707b2.jpg";